<template>
  <div style="min-height:100vh;background-color: #EDF1F7;" :class="{'mobile-member-ship-container':isMobile}">
    <header class="header-bg">
      <div><span @click="$router.push('/')">首页</span> > 会员权益</div>
      <div>云课堂VIP会员超值服务</div>
      <div>最新、最好、最全的教学视频</div>
    </header>
    <!--    会员权益-->
    <div class="box" v-if="!isMobile">
      <p class="member-rule">{{ memberRule }}</p>
      <img src="@assets/img/index/course-detail-bg.png" alt="">
<!--      <div class="authority-list-box">-->
<!--        -->
<!--      </div>-->
      <div v-for="(item,index) in authority" :key="item.price" class="authority-list">
        <div class="member-name">{{ item.name }}</div>
        <div class="pc-price-box">
          <div class="price-box">{{ item.price }}</div>
          <div>元/年</div>
        </div>
        <div class="original-price">
          <div v-if="index !=0">原价
            <del>￥{{ item.memberPrice }}</del>
          </div>
          <button v-if="index !=0" @click="displayModel(index,1)">{{ isMember ? '立即续费' : '立即开通' }}</button>
        </div>
        <div class="usage-scenario">
          <div>可使用场景</div>
        </div>
        <div v-for="(value,index) in displayList" :key="index" class="member-power">
          <div>{{ value.dictLabel }}</div>
          <div>
            <img v-if="value.dictValue!=0" :src="displayIcon(item.authorityList,value.dictValue)" alt="">
            <img v-if="value.dictValue ==0" src="@assets/img/member-ship/avatar.png" alt="头像">
            <img v-if="value.dictValue ==0" :src="item.icon" alt="" class="diamond-icon">
          </div>
        </div>
      </div>
    </div>
    <div class="box" v-else>
      <div class="choose-type-box">
        <div class="choose-type">选择类型</div>
        <p class="member-rule">{{ memberRuleTitle }}</p>
        <div v-for="(item, index) in memberRuleArr" :key="index">
          <p class="member-rule">{{ item.dictLabel }}</p>
        </div>
        <div class="member-name-price">
          <div @click="changeData(index)" :class="{'active-box':mobileCurrentActiveIndex===index}"
               v-for="(item,index) in memberData" :key="'power'+index">
            <div class="name-box">{{ item.memberName.substring(0, 2) }}VIP</div>
            <div><span style="font-size: 12px;">￥</span>{{ item.discountPrice }}<span style="color:#999;font-size: 14px">元/年</span>  </div>
            <div>日均{{ (item.discountPrice / 365).toFixed(2) }}元</div>
            <img v-if="index==1" src="@assets/img/member-ship/recommend-icon.png" alt="">
          </div>
        </div>
        <button @click="displayModel(mobileCurrentActiveIndex)">{{ isMember ? '立即续费' : '立即开通' }}</button>
      </div>
      <div v-if="mobileMemberData" class="authority-list">
        <div v-for="(value,index) in displayList" :key="index" class="member-power">
          <div>{{ value.dictLabel }}</div>
          <div>
            <img class="is-have-icon" v-if="value.dictValue!=0"
                 :src="displayIcon(authority[mobileCurrentActiveIndex+1].authorityList,value.dictValue)" alt="">
            <img class="avatar-box" v-if="value.dictValue ==0" src="@assets/img/member-ship/avatar.png" alt="头像">
            <img v-if="value.dictValue ==0" :src="mobileMemberData.icon" alt="" class="diamond-icon">
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="showPay"
             wrapClassName="wrapClassName"
             :confirmLoading="false"
             :footer="null"
             :closable="false"
             width="400px"
             :bodyStyle="bodyStyle"
             @ok="handleOk">
      <div>
        <div class="avatar-name">
          <a-avatar :src="userInfo.avatarUrl" style="margin-right: 8px"  :size="32" icon="user" /> {{ userInfo.nickname }}
        </div>
        <div class="modal" style="z-index: 1003">
          <a-tabs v-model="current" @change="callback">
            <a-tab-pane :key="index" :tab="item.memberName" v-for="(item,index) in memberData">
              <div class="model-main-content">
                <img v-if="index===0" class="line-image" src="@assets/img/member-ship/line.png" alt="">
                <img v-else class="line-image" src="@assets/img/member-ship/line-right.png" alt="">
                <!--                黄金封面 金额 原价盒子-->
                <div class="cover-price">
                  <div class="cover-box" :class="{'mobile-cover-box':isMobile}">
                    <img class="time-limit" src="@assets/img/member-ship/time-limit.png" alt="">
                    <!--                    显示黄金钻石-->
                    <img v-if="index==0" class="diamond-img" src="@assets/img/index/gold-diamond.png" alt="">
                    <!--                    显示钻石会员-->
                    <img v-else class="diamond-img" src="@assets/img/index/transparent-diamond.png" alt="">
                    <div>{{ item.memberName.substring(0, 2) }}VIP</div>
                  </div>
                  <div class="price-num-box">
                    <div style="margin-bottom: 10px"><span style="color: #F1534B;">￥</span><span
                        class="price-num">{{ item.discountPrice }}</span>元/年
                    </div>
                    <div>原价
                      <del>￥{{ item.memberPrice }}</del>
                    </div>
                  </div>
                </div>
                <div class="invite-code-box">
                  <input type="text" v-model="inviteCode" placeholder="请填写邀请码（选填）">
                </div>
              </div>
              <div class="bottom-button">
                <button @click="cancelModel">取消</button>
                <button @click="pay(item.id)">去支付</button>
              </div>
            </a-tab-pane>

          </a-tabs>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {systemDictText} from "@api/course-live-online";
import {directionOrderCreate} from "@api/courseDirection-api";
import {COURSE_ALREADY_PAID, SUCCESS} from "@constants/code";
import {showError, showMsg, showSuccessMsg} from "@utils/msg";
import {mapState} from "vuex";
import {getMemberData, payMemberExpense} from '@api/vip'
import errorIcon from "@assets/img/member-ship/error-icon.png"
import correctIcon from "@assets/img/member-ship/correct-icon.png"
import silveryIcon from "@assets/img/index/silvery-diamond.png"
import goldIcon from "@assets/img/index/gold-diamond.png"
import transparentIcon from "@assets/img/index/transparent-diamond.png"
import {debounce} from "ant-design-vue/lib/vc-table/src/utils";
import common from "@/mixin/common";
import {payCourse} from "@api/shopping-api";

export default {
  mixins: [common],
  data() {
    return {
      // model框样式
      bodyStyle: {
        padding: '20px',
        background: 'linear-gradient(180deg, #2D3750 0%, #151C37 100%)',
        borderRadius: '10px',
        transform: 'scale(1.02)'
      },
      //默认选中
      current: 0,
      // model框控制显示隐藏
      showPay: false,
      // 会员权益数据
      displayList: [],
      // 黄金会员、钻石会员数据
      memberData: {},
      // 邀请码
      inviteCode: '',
      // 权限
      authority: [],
      returnUrl: '',
      mobileCurrentActiveIndex: 1,
      mobileMemberData: {},
      memberRule: '',
      memberRuleTitle: '会员购买规则：',
      memberRuleArr: []
    }
  },
  created() {
    this.initData()
    this.returnUrl = location.protocol + "//" + location.host + "/other/pay-succeed"
    window.scrollTo(0, 0);
  },
  methods: {
    changeData(index) {
      this.mobileCurrentActiveIndex = index;
      this.mobileMemberData = this.authority[index + 1]
    },
    displayModel(index, type = 0) {
      this.current = index - type;
      this.showPay = true
    },
    // 判断显示X号还是对钩
    displayIcon(list, value) {
      if (list.find(res => res == value)) return correctIcon
      return errorIcon
    },
    // 初始化数据
    initData() {
      systemDictText('member_rule').then(res => {
        this.memberRuleArr = res.rows
        this.memberRule = this.memberRuleTitle
        if (Array.isArray(this.memberRuleArr) && this.memberRuleArr.length > 0) {
          for (let i = 0; i < this.memberRuleArr.length; i++) {
            this.memberRule += this.memberRuleArr[i].dictLabel
          }
        }
      })

      systemDictText('member_benefits').then(res => {
        this.displayList = res.rows
      })

      getMemberData().then(res => {
        this.memberData = res.data

        this.handleAuthority()
      })
    },
    // 支付调用
    pay: debounce(function (id) {
      // 获取订单
      payMemberExpense({memberId: id, invitationCode: this.inviteCode}).then(res => {
        if (res.code === 0) {
          // 去支付
          payCourse(res.data.orderId, this.returnUrl).then((args) => {
            this.spinning = false;
            if (args.code === 0) {
              //跳转支付宝
              window.location.href = args.url.body
            } else {
              // showError("跳转失败", args.msg);
            }
          })
        }
      })
    }, 500),
    // 点击取消
    cancelModel() {
      this.showPay = false;
    },
    callback(key) {
      console.log(key);
    },
    handleOk() {
      this.confirmLoading = true;
      this.okText = "订单生成中...";
      directionOrderCreate(this.directionId).then((res) => {
        if (res.code === SUCCESS) {
          // todo 跳转到详情界面
          showSuccessMsg("创建成功，即将跳转到支付界面...");
          setTimeout(() => {
            this.$router.push({
              name: 'payDetail',
              params: {
                orderId: res.order.orderId
              }
            })
          }, 300)
        } else if (res.code === COURSE_ALREADY_PAID) {
          showMsg("已自动帮您忽略了您已拥有的课程");
        } else {
          showError('创建订单失败', res.msg);
        }
        this.confirmLoading = false;
      })
    },
    handleAuthority() {
      this.authority[0] = {
        name: '青铜VIP',
        price: '0',
        icon: silveryIcon,
        authorityList: [0, 1]
      }
      this.memberData.forEach(item => {
        let list = item.memberDetailsList.map(item => item.memberBenefits)
        this.authority[item.memberSort] = {
          name: `${item?.memberName.substring(0, 2)}VIP`,
          price: item?.discountPrice,
          icon: item.id == 1 ? goldIcon : transparentIcon,
          memberPrice: item.memberPrice,
          id: item.id,
          authorityList: list
        }
      })
      console.log(this.authority)
      this.mobileMemberData = this.authority[this.mobileCurrentActiveIndex + 1]
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo
    })
  }
}
</script>

<style scoped lang="less">

.mobile-cover-box{
  margin-left: 7% !important;
}
.wrapClassName {
  .ant-modal {
    .ant-modal-content {
      background-color: #000 !important;
    }
  }

}

.mobile-member-ship-container {

  .header-bg {
    width: 100%;
    height: 140px;

    & > :nth-child(2) {
      font-size: 16px;
      margin-top: 10px;
    }

    & > :nth-child(3) {
      font-size: 12px;
      margin-top: 6px;
    }
  }

  .box {
    width: 90%;
    margin: -25px auto 0;
    flex-direction: column;
    background: transparent;
    height: auto;

    .authority-list {
      background-color: #fff;
      width: 100%;
      margin-top: 15px;
      border-radius: 6px;
      height: auto;

      .member-power {
        height: 40px;
        margin-top: 0;

        & > :nth-child(1) {
          font-size: 13px;
        }

        .is-have-icon {
          width: 13px;
        }

        .avatar-box {
          width: 36px;
        }
      }
    }

    .choose-type-box {
      padding: 13px 19px;
      border-radius: 6px;
      background: #fff;
      width: 100%;
      height: auto;
      font-weight: 500;
      color: #333;

      .choose-type {
        margin-bottom: 5px;
        position: relative;

        &::after {
          display: block;
          position: absolute;
          content: '';
          left: -6px;
          top: 4px;
          width: 2px;
          height: 14px;
          background: #00B278;
          border-radius: 1px;
        }
      }
      .member-rule {
        margin-bottom: 5px;
        font-size: 12px;
        color: #b7b7b7;
      }

      .member-name-price {
        display: flex;

        .active-box {
          border: 1px solid #00B278;

          & > :nth-child(1) {
            color: #00B278;
          }
        }

        & > div {
          margin-right: 10px;
          width: 120px;
          height: 106px;
          box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.11);
          border-radius: 5px;
          border: 0px solid #E2E2E2;
          display: flex;
          flex-direction: column;
          align-content: center;
          justify-content: center;
          position: relative;
          box-sizing: border-box;
          border: 1px solid transparent;
          text-align: center;

          & > :nth-child(2) {
            color: red;
            font-size: 22px;
          }

          & > :nth-child(3) {
            color: #999999;
            font-size: 12px;
          }

          img {
            width: 31px;
            position: absolute;
            right: 0px;
            top: 0px;
          }
        }
      }

      button {
        margin-top: 19px;
        width: 100%;
        height: 40px;
        background: linear-gradient(90deg, #FD952D 0%, #F1534B 100%);
        border-radius: 19px;
        border: none;
        color: #FFFFFF;
        font-size: 16px;
      }
    }
  }
}

/deep/ .anticon {
  color: #fff !important;
}

.original-price {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  color: #999;
  text-align: center;
  height: 87px;

  div {
    width: 100%;
    margin-bottom: 15px;
  }

  > button {
    width: 110px;
    height: 34px;
    background: linear-gradient(90deg, #FD952D 0%, #F1534B 100%);
    border-radius: 18px;
    border: none;
    color: #fff;
    margin: 0 auto 20px;
    cursor: pointer;
    font-size: 16px;
  }
}

/deep/ .ant-tabs-tab:hover {
  color: #fff;
}

input::-webkit-input-placeholder {
  color: #717582;
}

input::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #717582;
}

input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: #717582;
}

input:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #717582;
}

.price-num-box {
  color: #717582;
  font-size: 15px;

  .price-num {
    font-size: 36px;
    color: #F1534B;
  }
}

.bottom-button {
  text-align: center;
  color: #fff;
  font-size: 13px;

  button {
    width: 71px;
    height: 29px;
    border-radius: 18px;
    cursor: pointer;
  }

  & > :nth-child(1) {
    border: 1px solid #717582;
    background-color: transparent;
    margin-right: 12px;
  }

  & > :nth-child(2) {
    background: linear-gradient(90deg, #E1A061 0%, #F1534B 100%);
    border: none;
  }
}

.modal {
  margin-top: 21px;
  width: 100%;
  height: 360px;
  background-image: url("~@assets/img/member-ship/pay-bg.png");
  background-size: 100% 100%;

  .model-main-content {
    padding: 10px;

    .invite-code-box {
      margin: 22px 0;
      text-align: center;
    }

    input {
      width: 268px;
      height: 35px;
      border-radius: 3px;
      border: 1px solid #717582;
      padding-left: 15px;
      background-color: transparent;
      color: #ccc;
    }

  }

  .line-image {
    margin-top: -40px;
    width: 100%;
  }

  .cover-price {
    display: flex;
    align-items: center;

    .cover-box {
      margin-left: 42px;
      width: 107px;
      height: 107px;
      background-color: #fff;
      display: flex;
      align-items: center;
      flex-direction: column;
      border-radius: 11px;
      margin-right: 15px;
      color: #333;
      font-size: 22px;
      justify-content: center;
      position: relative;

      .diamond-img {
        width: 35px;
        margin-bottom: 6px;
      }

      .time-limit {
        position: absolute;
        right: 0;
        top: 0;
        width: 34px;
      }
    }
  }
}

/deep/ .ant-tabs-nav-scroll {
  padding: 20px 0 0 30px;
}

.avatar-name {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;

  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 5px;
  }
}


/deep/ .ant-tabs-ink-bar-animated {
  width: 0 !important;
}

/deep/ .ant-modal-content {
  background: red;
}

/deep/ .ant-tabs-tab-active {
  color: #E1A061 !important;
}

/deep/ .ant-tabs-tab {
  color: #FFFFFF;
}

.header-bg {
  width: 1200px;
  margin: 0 auto;
  background: url("~@assets/img/member-ship/member-ship-bg.png");
  height: 332px;
  color: #fff;
  padding: 20px;
  font-weight: 500;

  > div {
    span {
      cursor: pointer;
    }
  }

  & > :nth-child(2) {
    margin-top: 35px;
    font-size: 40px;
    color: #fff;
    text-align: center;
  }

  & > :nth-child(3) {
    margin-top: 20px;
    font-size: 20px;
    color: #9196a3;
    text-align: center;
  }
}

.usage-scenario {
  display: flex;
  justify-content: center;

  > div {
    color: #999999;
    font-size: 16px;
    position: relative;

    &::after {
      content: '';
      display: block;
      width: 90px;
      height: 1px;
      background: #ededed;
      position: absolute;
      left: -105px;
      top: 13px;
    }

    &::before {
      content: '';
      display: block;
      width: 90px;
      height: 1px;
      background: #ededed;
      position: absolute;
      left: 95px;
      top: 13px;
    }
  }
}

.box {
  margin-top: -112px;
  background: linear-gradient(180deg, #FFFFFF 0%, #EDF1F7 100%);
  border-radius: 15px;
  position: relative;
  display: flex;
  height: 837px;
  justify-content: space-around;
  font-weight: 500;


  > .member-rule {
    position: absolute;
    top: 0;
    z-index: 1000;
    margin: 15px 0;
    font-size: 12px;
    color: #b7b7b7;
  }

  > img {
    width: 150px;
    position: absolute;
    top: 0;
    left: calc(50% - 84px);
  }

  .authority-list {
    position: relative;
    width: 337px;
    padding: 0 30px;
    height: 763px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.11);
    border-radius: 15px;
    border: 1px solid #F1F1F1;
    margin-top: 54px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .member-name {
      margin: 34px 0 20px 0;
      color: #333333;
      font-size: 30px;
    }

    .pc-price-box {
      display: flex;
      align-items: center;
      height: 80px;

      .price-box {
        color: #F32425;
        font-size: 50px;
      }

      & > :nth-child(2) {
        margin: 15px 0 0 5px;
        color: #999999;
        font-size: 16px;
      }
    }

    .member-power {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #797979;
      font-size: 16px;
      margin-top: 30px;

      & > :nth-child(2) {
        width: 36px;
        text-align: center;
      }

      > div {
        position: relative;
      }

      .diamond-icon {
        position: absolute;
        left: 25px;
        bottom: 0px;
        width: 19px;
      }
    }
  }
}

/deep/ .ant-tabs-bar {
  border: none;
}
</style>
